export default __webpack_public_path__ + "static/media/gitHub.5827f4ae.svg";